import axios from 'axios';
import API_ROUTES from '../../routes/ApiRoutes.js';

export const getPricing = async () => {
    const { data } = await axios.get(API_ROUTES.PRICING_HOURS);
    return data;
};